import { render, staticRenderFns } from "./DoctorDetailsView.vue?vue&type=template&id=58976c0a"
import script from "./DoctorDetailsView.vue?vue&type=script&lang=js"
export * from "./DoctorDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports